import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpBearerInterceptor } from './http-bearer.interceptor';

export const httpBearerInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpBearerInterceptor, multi: true },
];
